import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { AppRoutes } from './routes/AppRoute';
import { PublicPageRedirect } from './components/PublicPageRedirect';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <PublicPageRedirect />
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
